import * as React from 'react';
import { SVGProps } from 'react';

const IconBarrierSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9H0V7h6V3zm10 4h-4v2h4V7z" />
  </svg>
);
export default IconBarrierSizeS;
